"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));

var _Chip = _interopRequireDefault(require("../Chip"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Image = _interopRequireDefault(require("../Image"));

var _Price = _interopRequireDefault(require("../Price"));

var _Text = _interopRequireDefault(require("../Text"));

var _Checkbox = _interopRequireDefault(require("../Checkbox"));

var _Container = _interopRequireDefault(require("../Container"));

var _Tag = _interopRequireDefault(require("../Tag"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Popover = _interopRequireDefault(require("../Popover"));

var _utilities = _interopRequireDefault(require("../../utilities"));

var _MealCard = _interopRequireDefault(require("./MealCard.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var StyledContainerWrapper = _styledComponents.default.div.withConfig({
  displayName: "MealCard__StyledContainerWrapper",
  componentId: "sc-5ge0cf-0"
})(["border:", ";border-radius:", ";position:relative;cursor:pointer;", ";"], function (_ref) {
  var isSelected = _ref.isSelected,
      theme = _ref.theme;
  return isSelected ? "1px solid ".concat(theme.colors.secondary) : 'none';
}, function (_ref2) {
  var isSelected = _ref2.isSelected,
      theme = _ref2.theme;
  return isSelected ? theme.borderRadius.small : 'none';
}, function (_ref3) {
  var isDisabled = _ref3.isDisabled,
      theme = _ref3.theme;
  return isDisabled && "&::after {\n    background-color: ".concat(theme.colors.default, ";\n    border-radius: ").concat(theme.borderRadius.normal, ";\n    content: '';\n    height: 100%;\n    opacity: 0.5;\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }");
});

var MainWrapper = _styledComponents.default.div.withConfig({
  displayName: "MealCard__MainWrapper",
  componentId: "sc-5ge0cf-1"
})(["padding:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.space.XSmall, " ").concat(theme.space.small);
});

var MealCardContainer = _styledComponents.default.div.withConfig({
  displayName: "MealCard__MealCardContainer",
  componentId: "sc-5ge0cf-2"
})(["display:flex;align-items:center;"]);

var CheckboxContainer = _styledComponents.default.div.withConfig({
  displayName: "MealCard__CheckboxContainer",
  componentId: "sc-5ge0cf-3"
})([""]);

var SelectedMealsContainer = _styledComponents.default.div.withConfig({
  displayName: "MealCard__SelectedMealsContainer",
  componentId: "sc-5ge0cf-4"
})([""]);

var TooltipConatiner = _styledComponents.default.div.withConfig({
  displayName: "MealCard__TooltipConatiner",
  componentId: "sc-5ge0cf-5"
})(["padding-top:", ";cursor:pointer;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.micro;
});

var ItemWrapper = _styledComponents.default.div.withConfig({
  displayName: "MealCard__ItemWrapper",
  componentId: "sc-5ge0cf-6"
})(["width:100%;position:relative;"]);

var InfoWrapper = _styledComponents.default.div.withConfig({
  displayName: "MealCard__InfoWrapper",
  componentId: "sc-5ge0cf-7"
})(["display:flex;grid-gap:", ";*{margin:auto 0;}"], function (_ref6) {
  var theme = _ref6.theme,
      isMobile = _ref6.isMobile;
  return isMobile ? theme.space.micro : theme.space.XSmall;
});

var DescriptionWrapper = _styledComponents.default.div.withConfig({
  displayName: "MealCard__DescriptionWrapper",
  componentId: "sc-5ge0cf-8"
})(["display:flex;flex-direction:", ";justify-content:space-between;width:", ";"], function (_ref7) {
  var isMobile = _ref7.isMobile;
  return isMobile ? 'column' : 'row';
}, function (_ref8) {
  var theme = _ref8.theme,
      isMobile = _ref8.isMobile;
  return isMobile ? '60%' : "calc(100% - 116px - ".concat(theme.space.small, ")");
});

var TagLabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "MealCard__TagLabelWrapper",
  componentId: "sc-5ge0cf-9"
})(["display:flex;flex-direction:column;grid-gap:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.space.micro;
});

var TitleWrapper = _styledComponents.default.div.withConfig({
  displayName: "MealCard__TitleWrapper",
  componentId: "sc-5ge0cf-10"
})(["display:flex;width:149px;align-items:flex-end;"]);

var PriceWrapper = _styledComponents.default.div.withConfig({
  displayName: "MealCard__PriceWrapper",
  componentId: "sc-5ge0cf-11"
})(["justify-self:self-end;"]);

var ComplimentaryDrinksWrapper = _styledComponents.default.div.withConfig({
  displayName: "MealCard__ComplimentaryDrinksWrapper",
  componentId: "sc-5ge0cf-12"
})(["margin-top:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.space.small;
});

var DrinksList = _styledComponents.default.div.withConfig({
  displayName: "MealCard__DrinksList",
  componentId: "sc-5ge0cf-13"
})(["display:flex;grid-gap:", ";overflow-x:auto;overflow-y:hidden;"], function (_ref11) {
  var theme = _ref11.theme,
      isMobile = _ref11.isMobile;
  return isMobile ? theme.space.micro : theme.space.small;
});

var DessertWrapper = _styledComponents.default.div.withConfig({
  displayName: "MealCard__DessertWrapper",
  componentId: "sc-5ge0cf-14"
})(["border-radius:", ";background-color:", ";padding:", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return "0 0 ".concat(theme.borderRadius.normal, " ").concat(theme.borderRadius.normal);
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.greyLighter;
}, function (_ref14) {
  var theme = _ref14.theme,
      isMobile = _ref14.isMobile;
  return isMobile ? "".concat(theme.space.small, " 0 ").concat(theme.space.XSmall, " ").concat(theme.space.small) : "".concat(theme.space.small, " 0 ").concat(theme.space.small, " ").concat(theme.space.large);
});

var DessertList = _styledComponents.default.div.withConfig({
  displayName: "MealCard__DessertList",
  componentId: "sc-5ge0cf-15"
})(["grid-gap:", ";"], function (_ref15) {
  var theme = _ref15.theme,
      isMobile = _ref15.isMobile;
  return isMobile ? theme.space.micro : theme.space.small;
});

var StyledSwitchWrapper = _styledComponents.default.div.withConfig({
  displayName: "MealCard__StyledSwitchWrapper",
  componentId: "sc-5ge0cf-16"
})([".MuiSwitch-thumb{color:", ";border:1px solid ", ";height:18px;width:18px;}.MuiSwitch-track{background-color:", ";}.Mui-checked{.MuiSwitch-thumb{color:", ";}&.MuiSwitch-colorSecondary{color:", ";& + .MuiSwitch-track{background-color:", ";}}&:hover.MuiSwitch-colorSecondary{background-color:rgba(75,79,166,0.04);}}"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.default;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.secondary;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.greyDark;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.secondary;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.secondary;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.secondary;
});

var ComplimentaryMealIconWrapper = _styledComponents.default.div.withConfig({
  displayName: "MealCard__ComplimentaryMealIconWrapper",
  componentId: "sc-5ge0cf-17"
})(["background-color:", ";border-radius:", ";padding:", ";position:absolute;width:", ";z-index:1;"], function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.yellow;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.space.small;
}, function (_ref24) {
  var theme = _ref24.theme;
  return "".concat(theme.space.micro, " ").concat(theme.space.micro, " 0");
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.space.small;
});

var BundleMealIconWrapper = _styledComponents.default.div.withConfig({
  displayName: "MealCard__BundleMealIconWrapper",
  componentId: "sc-5ge0cf-18"
})(["border-radius:", ";position:absolute;width:", ";z-index:1;"], function (_ref26) {
  var theme = _ref26.theme;
  return theme.space.small;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.space.small;
}); // eslint-disable-next-line react/prop-types


var TooltipContent = function TooltipContent(_ref28) {
  var labels = _ref28.labels;
  return labels.map(function (text) {
    return /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: _constant.SIZE.textSmall,
      color: _constant.COLOR.greyDarker
    }, text);
  });
};

var InlineWrapper = _styledComponents.default.div.withConfig({
  displayName: "MealCard__InlineWrapper",
  componentId: "sc-5ge0cf-19"
})(["display:flex;align-items:right;flex-direction:row;justify-content:flex-start;"]);

var CardContainer = _styledComponents.default.div.withConfig({
  displayName: "MealCard__CardContainer",
  componentId: "sc-5ge0cf-20"
})(["display:flex;align-items:right;flex-direction:column;justify-content:flex-start;"]);

var MealCard = function MealCard(_ref29) {
  var accessible = _ref29.accessible,
      theme = _ref29.theme,
      customProperties = _ref29.customProperties,
      translation = _ref29.translation,
      isMobile = _ref29.isMobile,
      handleOnSelect = _ref29.handleOnSelect,
      currency = _ref29.currency,
      meal = _ref29.meal,
      isDisabled = _ref29.isDisabled,
      handleReadOnly = _ref29.handleReadOnly,
      preventSelectionDisplay = _ref29.preventSelectionDisplay,
      isBundleSelected = _ref29.isBundleSelected,
      includedIcon = _ref29.includedIcon,
      isAtleastMealSelected = _ref29.isAtleastMealSelected,
      conversionRates = _ref29.conversionRates,
      priceSlashSuffix = _ref29.priceSlashSuffix;

  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);

  var _useState = (0, _react.useState)(meal.isSelected),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      mealSelected = _useState2[0],
      setMealSelected = _useState2[1];

  var _useState3 = (0, _react.useState)(meal.complimentaryDrinks ? meal.complimentaryDrinks.filter(function (d) {
    return d.isSelected;
  }) : []),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      selectedDrink = _useState4[0],
      setSelectedDrink = _useState4[1];

  var _useState5 = (0, _react.useState)(meal.addonDesserts ? meal.addonDesserts.filter(function (d) {
    return d.isSelected;
  }) : []),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      selectedDesserts = _useState6[0],
      setSelectedDesserts = _useState6[1];

  (0, _react.useEffect)(function () {
    if (!mealSelected) {
      setSelectedDrink([]);
      setSelectedDesserts([]);
    }
  }, [mealSelected]);

  var handleMealeSelect = function handleMealeSelect() {
    if (isDisabled) {
      return;
    }

    if (preventSelectionDisplay) {
      handleReadOnly(meal);
    } else {
      setMealSelected(!mealSelected);
    }
  }; // eslint-disable-next-line react-hooks/exhaustive-deps


  var computeTotalAmount = (0, _react.useCallback)(function (drinks, addons) {
    var _meal$price;

    var totalAmount = 0;
    totalAmount += (_meal$price = meal.price) !== null && _meal$price !== void 0 ? _meal$price : 0;

    if (drinks) {
      drinks.forEach(function (drink) {
        totalAmount += drink.price;
      });
    }

    if (addons) {
      addons.forEach(function (addonItem) {
        totalAmount += addonItem.price;
      });
    }

    return totalAmount;
  });
  (0, _react.useEffect)(function () {
    var mealData = null;
    var selectedDrinkForBundle;
    /**
     * bellow if code is for checking wether the meal is part of bundle or not if Yes
     * will add water bottle as selected and it will be part of bundle
     */

    if (meal.withBundle) {
      selectedDrinkForBundle = meal.complimentaryDrinks.find(function (drinks) {
        return drinks.id === _constant.WATER_BOTTLE_ID;
      });
      selectedDrinkForBundle = _objectSpread(_objectSpread({}, selectedDrinkForBundle), {}, {
        isSelected: true
      });
    }

    if (mealSelected) {
      mealData = _objectSpread(_objectSpread({}, meal), {}, {
        isSelected: true,
        complimentaryDrinks: selectedDrinkForBundle ? [].concat((0, _toConsumableArray2.default)(selectedDrink), [selectedDrinkForBundle]) : selectedDrink,
        addonDesserts: selectedDesserts,
        totalAmount: computeTotalAmount(selectedDrink, selectedDesserts)
      });
    }

    return handleOnSelect(mealData); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mealSelected, selectedDrink, selectedDesserts]);

  var isDrinkSelected = function isDrinkSelected(id) {
    return selectedDrink.findIndex(function (drink) {
      return drink.id === id;
    }) > -1;
  };

  var isDessertSelected = function isDessertSelected(id) {
    return selectedDesserts.findIndex(function (d) {
      return d.id === id;
    }) > -1;
  };

  var addRemoveSelectedDesserts = function addRemoveSelectedDesserts(dessertData) {
    if (isDessertSelected(dessertData.id)) {
      setSelectedDesserts(selectedDesserts.filter(function (d) {
        return d.id !== dessertData.id;
      }));
      return;
    }

    setSelectedDesserts([].concat((0, _toConsumableArray2.default)(selectedDesserts), [_objectSpread(_objectSpread({}, dessertData), {}, {
      isSelected: true
    })]));
  };

  var renderMealPrice = function renderMealPrice(mealPrice) {
    var price = _utilities.default.getConvertedCurrency(mealPrice !== null && mealPrice !== void 0 ? mealPrice : 0, currency, conversionRates);

    return _utilities.default.currencyFormat(price);
  };

  var renderPrice = function renderPrice(price) {
    var fontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'small';
    var strikethrough = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var color = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'greyDark';
    return /*#__PURE__*/_react.default.createElement(_Price.default, {
      amount: price,
      currency: currency,
      decimalType: "FLOAT",
      color: color,
      customFontSize: fontSize,
      priceTemplate: "TEMPLATE3",
      allowLocaleFormat: true,
      defaultIDRLocale: false,
      noDecimalValues: false,
      theme: theme,
      strikethrough: strikethrough
    });
  };

  var renderComplimentaryDrinks = function renderComplimentaryDrinks(drink) {
    var defaultSelected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var isSelected = defaultSelected || (selectedDrink ? isDrinkSelected(drink.id) : false);
    return /*#__PURE__*/_react.default.createElement(_Chip.default, {
      accessible: accessible,
      active: isSelected,
      activeBackgroundColor: "blue",
      activeBorderColor: "secondary",
      activeTextColor: "default",
      backgroundColor: "default",
      borderColor: "greyLight",
      customProperties: {
        id: drink.id
      },
      fontSize: isMobile ? 'XSmall' : 'small',
      hoverBackgroundColor: "default",
      hoverBorderColor: "secondary",
      hoverTextColor: "secondary",
      newTab: "TRUE",
      onChipClick: function onChipClick() {
        return isDisabled ? null : setSelectedDrink(isSelected ? [] : [_objectSpread(_objectSpread({}, drink), {}, {
          isSelected: true
        })]);
      },
      textColor: "neutral",
      theme: theme,
      key: "drink-".concat(drink.id),
      customPadding: _constant.CUSTOM_PADDING
    }, drink.name);
  };

  var renderComplimentaryDrinksList = function renderComplimentaryDrinksList(drinksList) {
    var withBundle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return /*#__PURE__*/_react.default.createElement(ComplimentaryDrinksWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      color: _constant.COLOR.greyDark,
      display: _constant.FLEX_PROPERTIES.inlineFlex,
      hasToggle: false,
      marginBottom: _constant.SIZE.micro,
      opacity: 1,
      tag: _constant.TAG.p,
      theme: theme,
      translation: {},
      type: _constant.SIZE.sub
    }, language.selectComplimentaryDrink), /*#__PURE__*/_react.default.createElement(DrinksList, {
      isMobile: isMobile
    }, drinksList.map(function (drink) {
      /**
       * defaultSelected IS THE DRINK WICH IS SELECTED WITH BUNDLE MEAL
       */
      var defaultSelected = withBundle && drink.id === _constant.WATER_BOTTLE_ID;
      return renderComplimentaryDrinks(drink, defaultSelected);
    })));
  };

  var renderPriceSlashData = function renderPriceSlashData(slashedPrice, discount, suffix) {
    return /*#__PURE__*/_react.default.createElement(InlineWrapper, null, renderPrice(slashedPrice), "\xA0", /*#__PURE__*/_react.default.createElement(_Tag.default, {
      backgroundColor: "greenLight",
      borderRadius: "4px",
      color: "tertiaryDark",
      margin: "4px 4px",
      padding: "3px 4px 3px 4px",
      type: "small"
    }, renderPrice(discount, 'default', false, 'tertiaryDark'), "\xA0", suffix));
  };

  var renderMealData = function renderMealData(mealData, isDessert) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isBundleSelected && mealData.isComplimentary && !isDisabled && /*#__PURE__*/_react.default.createElement(ComplimentaryMealIconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: true,
      color: "default",
      fontsize: "normal",
      icon: "StarIcon",
      theme: theme
    })), isBundleSelected && includedIcon && (!isAtleastMealSelected || mealData.withBundle) && /*#__PURE__*/_react.default.createElement(BundleMealIconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: true,
      color: _constant.COLOR.green,
      fontsize: _constant.SIZE.titleNormal,
      icon: includedIcon,
      theme: theme
    })), /*#__PURE__*/_react.default.createElement(InfoWrapper, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      accessible: accessible,
      centerFocus: true,
      enableProgressiveImageLoading: false,
      height: isMobile && isDessert ? '50px' : '70px',
      lazyLoadImage: false,
      placeHolderBackground: _constant.COLOR.tertiary,
      radius: "0px",
      src: mealData.imageUrl,
      theme: theme,
      width: isMobile && isDessert ? '80px' : '100px'
    }), /*#__PURE__*/_react.default.createElement(DescriptionWrapper, {
      isMobile: isMobile || isDessert
    }, /*#__PURE__*/_react.default.createElement(CardContainer, null, /*#__PURE__*/_react.default.createElement(TagLabelWrapper, null, mealSelected && mealData.isComplimentary && /*#__PURE__*/_react.default.createElement(_Tag.default, {
      accessible: true,
      backgroundColor: _constant.COLOR.greenLight,
      borderRadius: "4px",
      color: _constant.COLOR.tertiary,
      display: _constant.FLEX_PROPERTIES.inlineFlex,
      href: "https://www.airasia.com",
      margin: "5px 5px",
      padding: "1px 4px",
      tag: _constant.TAG.div,
      theme: theme,
      type: _constant.SIZE.semiSmall
    }, language.included), /*#__PURE__*/_react.default.createElement(TitleWrapper, null, mealData.isVeg && /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      display: _constant.FLEX_PROPERTIES.inlineFlex,
      hasToggle: false,
      opacity: 1,
      tag: _constant.TAG.p,
      theme: theme,
      translation: {},
      type: isMobile ? _constant.SIZE.default : _constant.SIZE.medium,
      color: _constant.COLOR.green
    }, "[V] \xA0"), /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      display: _constant.FLEX_PROPERTIES.inlineFlex,
      hasToggle: false,
      opacity: 1,
      tag: _constant.TAG.p,
      theme: theme,
      translation: {},
      type: _constant.SIZE.sub,
      bold: true
    }, mealData.name), mealData.labels && mealData.labels.length > 0 && /*#__PURE__*/_react.default.createElement(_Popover.default, {
      accessible: true,
      asToolTip: true,
      customProperties: {},
      position: _constant.POSITION.bottom,
      theme: theme,
      trigger: _constant.TRIGGER.click,
      width: 200,
      zIndex: 109,
      childWidth: _constant.CUSTOM_WIDTH.fitContent,
      outsideClck: true,
      content: /*#__PURE__*/_react.default.createElement(TooltipContent, {
        labels: mealData.labels
      })
    }, /*#__PURE__*/_react.default.createElement(TooltipConatiner, {
      id: _constant.TOOLTIP_ID
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: true,
      color: _constant.COLOR.neutral,
      fontsize: _constant.SIZE.medium,
      icon: "InfoOutlinedIcon",
      theme: theme
    }))))), /*#__PURE__*/_react.default.createElement(PriceWrapper, null, mealData.discount > 0 && mealData.slashedPrice > 0 && renderPriceSlashData(renderMealPrice(mealData.slashedPrice), renderMealPrice(mealData.discount), priceSlashSuffix), /*#__PURE__*/_react.default.createElement(_Price.default, {
      accessible: true,
      allowLocaleFormat: true,
      amount: renderMealPrice(mealData.price),
      boldAmount: false,
      color: mealData.price === 0 ? _constant.COLOR.green : _constant.COLOR.greyDarker,
      currency: currency,
      customFontSize: _constant.SIZE.small,
      defaultIDRLocale: true,
      hideCurrency: false,
      noDecimalValues: false,
      strikethrough: false,
      theme: theme,
      customCurrencySize: _constant.SIZE.normal
    })))), isDessert && /*#__PURE__*/_react.default.createElement(StyledSwitchWrapper, null, /*#__PURE__*/_react.default.createElement(_Switch.default, {
      checked: isDessertSelected(mealData.id),
      onChange: function onChange() {
        return isDisabled ? null : addRemoveSelectedDesserts(mealData);
      }
    }))));
  };

  var MealItem = /*#__PURE__*/_react.default.createElement(MainWrapper, null, /*#__PURE__*/_react.default.createElement(MealCardContainer, {
    onClick: handleMealeSelect
  }, /*#__PURE__*/_react.default.createElement(CheckboxContainer, null, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    accessible: accessible,
    disableAlignment: false,
    disableBottomMargin: true,
    disableCheckbox: isDisabled,
    disabledWithSelected: false,
    isFullWidth: true,
    isSelected: !preventSelectionDisplay && mealSelected,
    onChange: function onChange(value) {
      if (isDisabled) {
        return;
      }

      if (preventSelectionDisplay) {
        handleReadOnly(meal);
      } else {
        setMealSelected(value);
      }
    },
    theme: theme
  })), /*#__PURE__*/_react.default.createElement(ItemWrapper, null, renderMealData(meal, false))), /*#__PURE__*/_react.default.createElement(SelectedMealsContainer, null, mealSelected && meal.complimentaryDrinks && meal.complimentaryDrinks.length > 0 && renderComplimentaryDrinksList(meal.complimentaryDrinks, meal.withBundle)));

  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledContainerWrapper, {
    isSelected: mealSelected,
    isDisabled: isDisabled
  }, /*#__PURE__*/_react.default.createElement(_Container.default, {
    accessible: accessible,
    customProperties: customProperties,
    alignChildren: _constant.FLEX_PROPERTIES.start,
    focusEffect: false,
    gapChildren: "none",
    hasBoxShadow: true,
    height: "auto",
    hoverEffect: false,
    isSideBySide: false,
    layout: 2,
    theme: theme
  }, MealItem, mealSelected && meal.addonDesserts && meal.addonDesserts.length > 0 && /*#__PURE__*/_react.default.createElement(DessertWrapper, {
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    color: _constant.COLOR.greyDark,
    display: _constant.FLEX_PROPERTIES.inlineFlex,
    hasToggle: false,
    marginBottom: _constant.SIZE.micro,
    opacity: 1,
    tag: _constant.TAG.p,
    theme: theme,
    translation: {},
    type: _constant.SIZE.sub
  }, language.maximizeYourMeal), /*#__PURE__*/_react.default.createElement(DessertList, null, meal.addonDesserts.map(function (dessert) {
    return renderMealData(dessert, true);
  }))))));
};

MealCard.propTypes = _MealCard.default.PropTypes;
MealCard.defaultProps = _MealCard.default.DefaultProps;
var _default = MealCard;
exports.default = _default;